import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Inquiry from 'components/Inquiry'
import { API } from 'lib/api'
import { apiName } from 'config/api'


const PrintInquiry = () => {
    const { no } = useParams()
    const [data, setData] = useState(null)

    useEffect(() => {
        (async () => {
            const ret = await API.get(apiName, `/items/getInquiry?no=${no}`, {})
            ret.公開日 = new Date(ret.公開日)
            setData(ret)
        })()
    }, [no])

    return (
        <Inquiry
            data={data}
            print
            isLoading={!data}
        />
    )
}

export default PrintInquiry
